module.exports = __webpack_public_path__ + "img/p4_2.28290dd0.png";